import { BRAND_NAME } from "@/wab/shared/brand";
import * as React from "react";
import { Helmet } from "react-helmet";

export function documentTitle(title: string) {
  return (
    // @ts-ignore
    <Helmet>
      <title>{title ? `${title} - ${BRAND_NAME}` : BRAND_NAME}</title>
    </Helmet>
  );
}
